export default "__VITE_ASSET__CvEccEWa__"